import { buildUrlWithQuery } from './query';

/**
 * 외부 URL로 이동 (다른 포트/도메인)
 * - 전체 페이지 새로고침 발생
 */
export function navigateExternal(url: string): void {
  window.location.href = url;
}

/**
 * 외부 URL로 이동 + 쿼리 파라미터
 */
export function navigateExternalWithQuery(
  url: string,
  query: Record<string, string | number | boolean | undefined | null>
): void {
  window.location.href = buildUrlWithQuery(url, query);
}

/**
 * 새 탭에서 외부 URL 열기
 */
export function openExternal(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}

/**
 * 새 탭에서 외부 URL 열기 + 쿼리 파라미터
 */
export function openExternalWithQuery(
  url: string,
  query: Record<string, string | number | boolean | undefined | null>
): void {
  window.open(buildUrlWithQuery(url, query), '_blank', 'noopener,noreferrer');
}
